import { useEffect, useRef } from "react";
import Headerdash from "../components/headerdash";

const Subscriberslist = () => {
    const subscribers = useRef();
    const unsubscribers = useRef();
    const dlsubs = () => {
        let tr = document.querySelector('tbody').querySelectorAll('tr');
        let csv = '';
        let i = 0;
        while(i < tr.length) {
            let tda = tr[i].querySelectorAll('td');
            csv += tda[0].innerHTML + ',' + tda[1].innerHTML + '\n';
            i++;
        }
        console.log(window.URL.createObjectURL(new Blob([csv], {type: 'text/csv'})));
        window.location.href = window.URL.createObjectURL(new Blob([csv], {type: 'text/csv'}));
    }
    useEffect(() => {
        fetch('https://api.voicecoach.net/getsubs', {credentials: 'include'})
        .then(res => res.json()).then(rt => {
            var r = Object.keys(rt).map(naam => '<tr><td>' +naam+'</td><td>'+ rt[naam]+'</td></tr>');
            subscribers.current.innerHTML = r.join('');
        });
        fetch('https://api.voicecoach.net/getunsubs', {credentials: 'include'})
        .then(res => res.json()).then(rt => {
            var r = Object.keys(rt).map(naam => '<tr><td>' +naam+'</td><td>'+ rt[naam]+'</td></tr>');
            unsubscribers.current.innerHTML = r.join('');
        });
    });
    return <>
    <Headerdash />
    <section className="container my-4">
<div className="row">
    <div className="col-12 col-lg-6">
    <h3>List of Subscribers (<span style={{"cursor":"pointer"}} className="text-primary" title="Cool feature, huh!?" onClick={dlsubs}>download</span>)</h3>
<table className="table">
    <thead>
    <tr><th>Name</th><th>Email address</th></tr>
    </thead>
    <tbody ref={subscribers} className="table-stripped table-hover">
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
    </tbody>
</table>
</div>
<div className="col-lg-6 col-12">
<h3>List of Unsubscribers</h3>
<table className="table">
    <thead>
    <tr><th>Name</th><th>Email address</th></tr>
    </thead>
    <tbody ref={unsubscribers} className="table-stripped table-hover">
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
        <tr className="loading"><td colSpan={2}></td></tr>
    </tbody>
</table>
</div>
</div>
</section>
</>
}

export default Subscriberslist;